import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {useLocation, useNavigate, useParams, useSearchParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {
    AutoComplete,
    Button,
    Checkbox,
    Col,
    Divider,
    Dropdown,
    Empty,
    Form,
    Input,
    message,
    Row,
    Select,
    Tooltip,
    TreeSelect,
} from "antd";
import DG_Form from "../../../../custom/data-entry/form";
import {setHeader} from "../../../../redux/actions/layout/interaction/action";
import {
    CloseOutlined,
    CopyOutlined,
    ExclamationCircleOutlined,
    LeftOutlined,
    PlusCircleOutlined,
    RightOutlined
} from "@ant-design/icons";
import {
    getAllTaskLabel,
    getKeyword,
    getSalaryConfigById,
    postSalaryConfig,
    putSalaryConfig
} from "../../../../api/hrm/wage/salaryconfig";
import {useTranslation} from "react-i18next";
import {getFormulaKeyword} from "../../../../api/setting/timekeeping/timekeeping-formula/api";
import DG_Button from "../../../../common/button/Button";
import DG_Cancel from "../../../../common/button/Cancel";
import SelectEmployee from "../../../../custom/data-entry/select-employee-work/SelectEmployee";
import useLazyRefetch from "../../../../custom/graphql/useLazyRefetch";
import {GET_SALARY_CONFIG_ID, GET_SALARY_CONFIGS} from "../../../../api/hrm/wage/salaryconfig/indexGql";
import {t} from "i18next";
import {AbilityUtil} from "../../../../custom/permission/Can";
import {ActionKeys, SubjectName} from "../../../../custom/permission/Ability";
import {useMainLayoutContext} from "../../../../layoutv2";
import {debounce} from "lodash/function";
import {DELAY_DEBOUNCE} from "../../../../common/config-variable/notification";
import {useLazyQuery} from "@apollo/client";
import {usedGraphqlLazyQuery} from "../../../../custom/graphql/graphql-client";
import {DoSelects} from '@dogoo/do-selects'
import {useMainAppContext} from '../../../../hooks/useMainAppContext'
import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";
import {
    doPosReference,
    doWorkReference,
    getDataReference,
    getDoPosReference,
    getKeyWorkEspecially,
    getTaskLabelReference,
    mapperKeyWord,
    mapTaskLabel
} from "../salary/item/keyReference";
import uuid from "react-uuid";
import {CONVERT_REF_CODE_BY_SALARY_CONFIG, REF_CODE_BY_SALARY_CONFIG} from "../salary/item/typeSalaryConfig";

const {Option} = Select;

const AddSalaryConfig = (props) => {
    const {id} = useParams();
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const dayAutoGenerated = [];
    const [dataKeyWord, setDataKeyWord] = useState([]);
    const [autoGenerated, setAutoGenerated] = useState(false);
    const [payroll, setPayroll] = useState(false);
    const [report, setReport] = useState(false);
    const [loading, setLoading] = useState(false);
    const {doConfigObject} = useMainLayoutContext()
    const [defaultApproval, setDefaultApproval] = useState();
    const [disableItems, setDisableItems] = useState(new Set());

    const condition = useMemo(() => {
        return doConfigObject?.find(item => item?.appCode === "SALARY" && item?.moduleCode === "TIMEKEEPING");
    }, [doConfigObject])

    const [searchParams] = useSearchParams();
    const {fetchIfNeeded} = useLazyRefetch(GET_SALARY_CONFIGS)
    const [fetchSalaryConfigId] = useLazyQuery(GET_SALARY_CONFIG_ID)

    const page = searchParams.get("page");
    const pageSize = searchParams.get("pageSize");
    const sort = searchParams.get("sort")
    const {filter, search} = useSelector(state => state.layoutInteractionReducer)
    let navigate = useNavigate();
    const {t} = useTranslation()
    const [isVisible, setIsVisible] = useState([{
        key: 0,
        value: true
    }]);
    const [dataKeyWorkEspecially, setDataKeyWorkEspecially] = useState([])
    const [dataTaskLabel , setDataTaskLabel]  = useState([])

    const {employeeReference, departmentData} = useMainAppContext()

    const [externalReferenceCode,setExternalReferenceCode] = useState(null)
    const [isAddDone ,setIsAddDone] = useState(!window.location.pathname.includes("wage/template/add"))
    const isSubmittedRef = useRef(isAddDone);
    const location = useLocation();
    const mode = location.pathname.includes("/add") ? "add" : "update";
    const addExternalReferenceCode = useRef(null);

    useEffect(() => {
        if (!id) {
            dispatch(setHeader(t("salary-config.title-save")), null)
        } else {
            dispatch(setHeader(t("salary-config.title-edit")), null)
        }
        getFormulaKeyword("MONTHLY_APPLICATION_KEYWORD").then((res) => {
            setDataKeyWord(res.items)
        })
        getKeyword(t).then((res) => {
            setDataKeyWorkEspecially(res?.items)
        })

        getAllTaskLabel().then(res => {
            setDataTaskLabel(mapTaskLabel(res,t))
        })

    }, []);

    useEffect(() => {

        if (!id) {
            const code = REF_CODE_BY_SALARY_CONFIG(uuid())
            addExternalReferenceCode.current = code;
            setExternalReferenceCode(code)
            form.resetFields()
            form.setFieldsValue({
                salaryColumns: [{

                    "columnName": "A",
                    "valueColumn": t("layout.keyword.MA_NHAN_SU"),
                    "titleColumn": t("layout.keyword.MA_NHAN_SU"),
                    "keyColumn": "MA_NHAN_SU",
                    "calculation": "",
                    "rowValue": "valuelastrow",
                    "typeValue": null,
                    "paycheck": "presently",
                    "valueSynthetic": null,
                    "describe": ""

                }]
            });
            setDisableItems(new Set([0]))
        }

    }, [id]);

    useEffect(() => {
        if (id) {
            getSalaryConfigById(id).then((response) => {
                setExternalReferenceCode(REF_CODE_BY_SALARY_CONFIG(response?.externalReferenceCode))
                form.setFieldsValue(mapDataUpdate(response),)
            })
        }
    }, [id])

    async function reLoadPage() {
        fetchIfNeeded({filter, page, pageSize, search, sort})

    }

    const onFinish = (values) => {
        setLoading(true)
        values.report = report;
        if (!id) {
            postSalaryConfig({
                ...values,
                externalReferenceCode : CONVERT_REF_CODE_BY_SALARY_CONFIG(externalReferenceCode)
            }).then((response) => {
                setIsAddDone(true)
                isSubmittedRef.current = true
                if (response.status === 204) {
                    message.success(t("salary-config.message.add")).then(() => {})
                }
                fetchIfNeeded({filter, page, pageSize, search, sort}).then(() => {
                        navigate(-1)
                    }
                )


            }).catch((error) => {
            }).finally(() => setLoading(false))
        }
        else {
            putSalaryConfig(id, values).then((response) => {
                setIsAddDone(true)
                isSubmittedRef.current = true
                message.success(t("salary-config.message.edit")).then(() => {
                })
                usedGraphqlLazyQuery(fetchSalaryConfigId, {id: id}).then(r => {
                })
                reLoadPage().then(() => {
                    navigate(-1)
                })
            }).catch((error) => {
            }).finally(() => setLoading(false))

        }
    }

    function mapDataUpdate(from) {
        setDefaultApproval(from?.approvalId);
        if (Object.keys(from).length === 0) {
            return {};
        }
        if (from.keyword !== "") {
            setPayroll(true)
        } else {
            setPayroll(false)
        }

        let applyDepartment = [];
        from?.applyDePartments?.forEach((item) => {
            if (item?.departmentId !== 0) {
                applyDepartment.push(item?.departmentId)
            }
        })
        let applyPosition = [];
        from?.applyPositions?.forEach((item) => {
            applyPosition.push(item?.jobPositionId)
        })

        let employeeManage = [];
        from?.employeeManages?.forEach((item) => {
            employeeManage.push(item?.employeeId)
        })

        let employeeFollow = [];
        from?.employeeFollows?.forEach((item) => {
            employeeFollow.push(item?.employeeId)
        })
        if (from?.autoGenerated == 0) {
            setAutoGenerated(false)
        } else {
            setAutoGenerated(true)
        }
        setReport(from.report)
        return ({
            name: from?.name,
            keyword: from?.keyword,
            applyDepartmentIds: applyDepartment,
            applyPositionIds: applyPosition,
            salaryType: from?.salaryType,
            employeeManageIds: employeeManage,
            employeeFollowIds: employeeFollow,
            autoGenerated: from?.autoGenerated != 0 ? from?.autoGenerated : null,
            salaryColumns: mapColumnList(from),
            approvalId: from?.approvalId
        })
    }

    function mapColumnList(from) {
        let arrayKey = []
        const disableTemp = new Set()
        const res =  from?.salaryColumns?.map((item, index) => {

            if(!(item?.valueColumn === "CONGTHUC"
                || item?.valueColumn === "HANGSO" || item?.valueColumn === "IMPORT" || item?.keyColumn === "SALARY_END")){
                disableTemp?.add(index)

            }

            arrayKey.push({
                key: index,
                value: true
            })
            setIsVisible(arrayKey);

            if (item?.valueColumn === "CONGTHUC"
                || item?.valueColumn === "HANGSO") {
                arrayKey.push({
                    key: index,
                    value: false
                })
                setIsVisible(arrayKey);
            }
            return ({
                ...item,
                columnName: item?.columnName,
                valueColumn: item?.valueColumn,
                titleColumn: item?.titleColumn,
                keyColumn: item?.keyColumn,
                calculation: item?.calculation,
                rowValue: item?.rowValue,
                typeValue: item?.typeValue ? item?.typeValue : null,
                paycheck: item?.paycheck,
                valueSynthetic: item?.valueSynthetic ? item?.valueSynthetic : null,
                describe: item?.describe

            })
        })
        setDisableItems(disableTemp)
        return res ;
    }

    const onChangeAddRow = () => {
        const fields = form.getFieldsValue();
        const {salaryColumns} = fields;
        salaryColumns.map((item, index) => {
            if (!salaryColumns[index]) {
                salaryColumns[index] = {};
            }
            Object.assign(salaryColumns[index], {
                ...index,
                columnName: colunmsKeys[index],
            });
            form.setFieldsValue({
                salaryColumns,
            });
        })
    };

    const onChangeKeyWord = (value, key,option) => {

        if(!option?.enabled){
            setDisableItems(new Set(disableItems)?.add(key))
        }
        else {
            const updatedSet = new Set(disableItems);
            updatedSet?.delete(key);
            setDisableItems(updatedSet);
        }

        const dataAll = dataKeyWord.concat(dataKeyWorkEspecially).concat(doWorkReference(t)).concat(doPosReference(t)).concat(dataTaskLabel);
        let dataDetail = dataAll.filter(item => item?.column === value || item?.keyColumn === value)
        const fields = form.getFieldsValue();
        const {salaryColumns} = fields;

        let array = []
        isVisible.map(item => array.push(item));
        if (dataDetail[0]?.keyColumn !== undefined) {
            dataKeyWorkEspecially.filter(i => value === i?.keyColumn).forEach((item, index) => {
                array.push({
                    key: key,
                    value: false
                })
            })
            setIsVisible(array);

            Object.assign(salaryColumns[key], {
                ...key,
                valueColumn: dataDetail[0]?.name, // todo
                titleColumn: dataDetail[0]?.name,
                keyColumn: dataDetail[0]?.keyColumn,
                calculation: dataDetail[0]?.calculation,
                typeValue: dataDetail[0]?.typeValue ? dataDetail[0]?.typeValue : null
            });
            form.setFieldsValue({
                salaryColumns,
            });


        }
        else if (value === "CONGTHUC" || value === "HANGSO" || value === "IMPORT" || value === "STT") {
            array.push({
                key: key,
                value: !(value === "CONGTHUC" || value === "HANGSO")
            })
            setIsVisible(array);
            if (value === "CONGTHUC" || value === "IMPORT") {
                Object.assign(salaryColumns[key], {
                    ...key,
                    titleColumn: "",
                    keyColumn: "",
                    calculation: "",
                    describe: t("tnp.components.salary.inputData")
                });
                form.setFieldsValue({
                    salaryColumns,
                });
            }

            if (value === "HANGSO") {
                Object.assign(salaryColumns[key], {
                    ...key,
                    typeValue: "number",
                    calculation: "100"
                });
                form.setFieldsValue({
                    salaryColumns,
                });
            }
            if (value === "STT") {
                Object.assign(salaryColumns[key], {
                    ...key,
                    typeValue: "number",
                    titleColumn: "STT",
                    keyColumn: "STT"
                });
                form.setFieldsValue({
                    salaryColumns,
                });
            }
        }
        else if (dataDetail[0]?.column !== undefined) {
            array.push({
                key: key,
                value: true
            })
            setIsVisible(array);
            Object.assign(salaryColumns[key], {
                ...key,
                valueColumn: dataDetail[0]?.name,
                titleColumn: dataDetail[0]?.name,
                keyColumn: dataDetail[0]?.column,
                calculation: dataDetail[0]?.defaultValue,
                typeValue: dataDetail[0]?.value ? dataDetail[0]?.value : null

            });
            form.setFieldsValue({
                salaryColumns,
            });
        }

        form.validateFields([
            ["salaryColumns", key, "valueColumn"],
            ["salaryColumns", key, "titleColumn"],
            ["salaryColumns", key, "keyColumn"]]);

    }



    for (let i = 1; i < 32; i++) {
        dayAutoGenerated.push(<Option key={i} value={i}>{t("salary-config.fields.day") + " "}{i}</Option>);
    }

    const tProps = {
        treeCheckable: true,
        style: {
            width: "100%"
        }
    };

    const debouncedAdd = useCallback(
        debounce((form) => {
            form.submit()
        }, DELAY_DEBOUNCE),
        []);

    const handleAdd = () => {
        debouncedAdd(form)
    };
    const filterOption = (inputValue, option) => {
        const normalizedInput = inputValue?.toLowerCase()?.normalize("NFD")?.replace(/[\u0300-\u036f]/g, "");
        const normalizedOption = option?.title?.toLowerCase()?.normalize("NFD")?.replace(/[\u0300-\u036f]/g, "");

        return normalizedOption?.includes(normalizedInput);
    }

    function addDisableKeyTemp(item, disableTemp, index) {
        if (!(item?.valueColumn === "CONGTHUC"
            || item?.valueColumn === "HANGSO" || item?.valueColumn === "IMPORT" || item?.keyColumn === "SALARY_END")) {
            disableTemp?.add(index)

        }
    }
    // bỏ vì upload file được bỏ
    // useEffect(() => {
    //     isSubmittedRef.current = isAddDone;
    // }, [isAddDone]);


    // useEffect(() => {
    //     if(window.location.pathname.includes("wage/template/add")){
    //         setIsAddDone(false)
    //     }
    //     const handleBeforeUnload = (event) => {
    //         if (mode === "add" && !isSubmittedRef.current) {
    //             deleteFiles(addExternalReferenceCode?.current);
    //         }
    //     };
    //     window.addEventListener("beforeunload", handleBeforeUnload);
    //     return () => {
    //         window.removeEventListener("beforeunload", handleBeforeUnload);
    //         if (mode === "add" && !isSubmittedRef.current && addExternalReferenceCode !== null) {
    //             deleteFiles(addExternalReferenceCode?.current);
    //         }
    //     };
    // },[mode])

    return (
        <div style={{height: "100%", overflow: 'hidden'}}
             className={" rounded-lg h-full"}>
            <DG_Form form={form}
                     layout="vertical"
                     mode={!id ? "add" : "update"}
                     onFinish={onFinish}
                     scrollToFirstError>

                <DG_Button title={!id ? t("tnp.components.salary.text162") : t("tnp.components.salary.text163")}>
                    <Button
                        onClick={handleAdd}
                        type={"primary"}
                        loading={loading}
                        disabled={!AbilityUtil.allow(ActionKeys.CREATE, SubjectName.salaryTable, {})}
                    >
                        {id ? t("tnp.button.update") : t("tnp.button.create")}
                    </Button>
                    <DG_Cancel/>
                </DG_Button>

                <div className={"px-6 py-3 bg-white"} style={{
                    overflowY: "auto",
                    height: "calc(100vh - 68px - 100px)"
                }}>
                    <Row gutter={12}>
                        <Col
                            xxl={{span: 8}}
                            xl={{span: 8}}
                            lg={{span: 8}}>
                            <Form.Item
                                label={t("salary-config.fields.name")}
                                name={"name"}
                                rules={[{required: true}]}>
                                <Input/>
                            </Form.Item>
                        </Col>
                    </Row>
                    {/*<Row gutter={12}>*/}
                    {/*    <Col*/}
                    {/*        xxl={{span: 8}}*/}
                    {/*        xl={{span: 8}}*/}
                    {/*        lg={{span: 8}}>*/}
                    {/*        <Checkbox checked={payroll}*/}
                    {/*                  onClick={(e) =>*/}
                    {/*                      setPayroll(e.target.checked)}>*/}
                    {/*            {t("salary-config.fields.other-tables")}</Checkbox>*/}
                    {/*    </Col>*/}
                    {/*</Row>*/}
                    <Row gutter={12}>
                        <Col
                            xxl={{span: 8}}
                            xl={{span: 8}}
                            lg={{span: 8}}
                        >
                            <Divider className="margin-0"/>
                        </Col>
                    </Row>
                    {payroll ? <Row gutter={12}>
                        <Col
                            xxl={{span: 8}}
                            xl={{span: 8}}
                            lg={{span: 8}}>
                            <Form.Item
                                label={t("salary-config.fields.keyword")}
                                name={"keyword"}>
                                <Input/>
                            </Form.Item>
                        </Col>
                    </Row> : <></>}
                    <Row gutter={12}>
                        <Col
                            xxl={{span: 8}}
                            xl={{span: 8}}
                            lg={{span: 8}}>
                            <Form.Item
                                rules={[{required: true}]}
                                label={t("salary-config.fields.apply-department")}
                                name={"applyDepartmentIds"}
                            >
                                <DoSelects
                                    placeholder={t('tnp.components.common.text4')}
                                    data={departmentData}
                                    selectType={'department'}
                                    {...tProps}
                                    all
                                    treeCheckable={"true"}
                                    showCheckedStrategy={TreeSelect.SHOW_ALL}
                                    name="applyDepartmentIds"
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={12}>
                        <Col
                            xxl={{span: 8}}
                            xl={{span: 8}}
                            lg={{span: 8}}>
                            <Form.Item
                                label={t("salary-config.fields.apply-position")}
                                name={"applyPositionIds"}
                            >
                                <DoSelects
                                    data={employeeReference}
                                    selectType={'position'}
                                    mode={"multiple"}
                                    placeholder={t("tnp.components.salary.text164")}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={12}>
                        <Col
                            xxl={{span: 8}}
                            xl={{span: 8}}
                            lg={{span: 8}}>
                            <Form.Item
                                rules={[{required: true}]}
                                label={t("salary-config.fields.salaryType")}
                                initialValue={"main"}
                                name={"salaryType"}>
                                <Select
                                    style={{
                                        width: '100%',
                                    }}
                                >
                                    <Option key={"main"} value={"main"}> {t("salary-config.fields.main")}
                                    </Option>
                                    <Option key={"extra"} value={"extra"}> {t("salary-config.fields.extra")}
                                    </Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    {/*<Row gutter={12}>*/}
                    {/*    <Col*/}
                    {/*        xxl={{span: 8}}*/}
                    {/*        xl={{span: 8}}*/}
                    {/*        lg={{span: 8}}>*/}
                    {/*        <Checkbox checked={report}*/}
                    {/*                  onClick={(e) =>*/}
                    {/*                      setReport(e.target.checked)}>*/}
                    {/*            {t("salary-config.fields.report")}</Checkbox>*/}
                    {/*    </Col>*/}
                    {/*</Row>*/}
                    <Row gutter={12}>
                        <Col
                            xxl={{span: 8}}
                            xl={{span: 8}}
                            lg={{span: 8}}
                        >
                            <Divider className="margin-0"/>
                        </Col>
                    </Row>
                    <Row gutter={12}>
                        <Col
                            xxl={{span: 8}}
                            xl={{span: 8}}
                            lg={{span: 8}}>
                            <Form.Item
                                label={t("salary-config.fields.employee-manage")}
                                name={"employeeManageIds"}>
                                <SelectEmployee
                                    placeholder={t("salary-config.placeholder.employee-manage")}
                                    mode={"multiple"}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={12}>
                        <Col
                            xxl={{span: 8}}
                            xl={{span: 8}}
                            lg={{span: 8}}>
                            <Form.Item
                                label={t("salary-config.fields.employee-follow")}
                                name={"employeeFollowIds"}
                            >
                                <SelectEmployee
                                    placeholder={t("salary-config.placeholder.employee-follow")}
                                    mode={"multiple"}
                                    defaultActiveFirstOption={false}
                                    filterOption={false}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={12}>
                        <Col
                            xxl={{span: 8}}
                            xl={{span: 8}}
                            lg={{span: 8}}>
                            <Checkbox checked={autoGenerated}
                                      onClick={(e) =>
                                          setAutoGenerated(e.target.checked)}>
                                {t("salary-config.fields.autoGenerated-checked")}
                                <Tooltip className={'ml-2'}
                                         title={t("tnp.components.salary.text165")}>
                                    <ExclamationCircleOutlined/>
                                </Tooltip>
                            </Checkbox>
                        </Col>
                    </Row>
                    <Row gutter={12}>
                        <Col
                            xxl={{span: 8}}
                            xl={{span: 8}}
                            lg={{span: 8}}
                        >
                            <Divider className="margin-0"/>
                        </Col>
                    </Row>
                    {autoGenerated ? <Row gutter={12}>
                        <Col
                            xxl={{span: 8}}
                            xl={{span: 8}}
                            lg={{span: 8}}>
                            <Form.Item
                                label={t("salary-config.fields.autoGenerated")}
                                name={"autoGenerated"}
                                tooltip={t("tnp.components.salary.text166")}
                            >
                                <Select
                                    name="autoGenerated"
                                    optionFilterProp="children"
                                    style={{width: "100%"}}
                                    placeholder={t("salary-config.placeholder.rowValue")}>
                                    {dayAutoGenerated}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row> : <></>}

                    {!condition?.doId && <Row gutter={12}>
                        <Col
                            xxl={{span: 8}}
                            xl={{span: 8}}
                            lg={{span: 8}}
                        >
                            <Form.Item
                                name="approvalId"
                                label={t("shiftWorkForm.approvalId")}


                                rules={[
                                    {
                                        required: true,
                                        message: t("shiftWorkForm.approvalIdMessage"),
                                    },
                                ]}
                            >
                                <SelectEmployee
                                    placeholder={t("shiftWorkForm.approvalIdEnter")}
                                    defaultActiveFirstOption={false}
                                    filterOption={false}
                                    employeeCurrent={defaultApproval}
                                />
                            </Form.Item>
                        </Col>
                    </Row>}


                    <Row gutter={24} wrap={false} className={"mb-6"}>
                        <Col xxl={{span: 1}} xl={{span: 1}} lg={{span: 1}}/>
                        <Col xxl={{span: 1}} xl={{span: 2}} lg={{span: 2}} xs={{span: 2}} sm={{span: 2}} md={{span: 2}}>{t("salary-config.fields.columnName")}</Col>
                        <Col xxl={{span: 6}} xl={{span: 6}} lg={{span: 6}}>{t("salary-config.fields.valueColumn")} <span style={{color : 'red'}}>*</span></Col>
                        <Col xxl={{span: 4}} xl={{span: 4}} lg={{span: 4}}>{t("salary-config.fields.titleColumn")} <span
                            style={{color: 'red'}}>*</span></Col>
                        <Col xxl={{span: 6}} xl={{span: 6}} lg={{span: 6}}>{t("salary-config.fields.keyColumn")} <span
                            style={{color: 'red'}}>*</span></Col>
                        <Col xxl={{span: 7}} xl={{span: 7}} lg={{span: 7}}>{ t("salary-config.fields.calculation")}
                            <Tooltip className={'ml-2'} title={t("formulaPlaceholder.formula")} >
                                <ExclamationCircleOutlined/>
                            </Tooltip>
                        </Col>
                        <Col xxl={{span: 8}} xl={{span: 8}} lg={{span: 8}}>{ t("salary-config.fields.rowValue")}</Col>
                        <Col xxl={{span: 3}} xl={{span: 4}} lg={{span: 4}}>{ t("salary-config.fields.typeValue")}</Col>
                        <Col xxl={{span: 3}} xl={{span: 4}} lg={{span: 4}}>{ t("salary-config.fields.formatOption")}</Col>
                        <Col xxl={{span: 3}} xl={{span: 4}} lg={{span: 4}}>{ t("salary-config.fields.paycheck")}</Col>
                        <Col xxl={{span: 4}} xl={{span: 4}} lg={{span: 4}}>{ t("salary-config.fields.valueSynthetic")}</Col>
                        <Col xxl={{span: 5}} xl={{span: 5}} lg={{span: 5}}>{ t("salary-config.fields.describe")}</Col>

                    </Row>
                    <Form.List name={"salaryColumns"} initialValue={id ? null : [""]}>
                        {(fields, {add, remove}) => (
                            <DragDropContext onDragEnd={(result) => {
                                if (!result.destination) return;

                                const {source, destination} = result;


                                const currentValues = form.getFieldValue('salaryColumns');
                                const reorderedValues = [...currentValues];
                                const [removed] = reorderedValues.splice(source.index, 1);
                                reorderedValues.splice(destination.index, 0, removed);

                                const res = reorderedValues.map((item, key) => {
                                    return {
                                        ...item,
                                        columnName: colunmsKeys[key]
                                    }
                                })
                                const disableTemp = new Set()
                                res?.map((item ,index ) => {
                                    addDisableKeyTemp(item, disableTemp, index);
                                })
                                setDisableItems(disableTemp)

                                form.setFieldsValue({salaryColumns: res});

                            }}>
                                <Droppable droppableId="droppable">
                                    {(provided) => (
                                        <div ref={provided.innerRef} {...provided.droppableProps}>

                                            <>
                                                {fields.map(({key, name, fieldKey, ...restField}, index) => {
                                                        return (
                                                            <Draggable key={key} draggableId={key.toString()} index={index}>
                                                                {(provided) => (
                                                                    <div
                                                                        ref={provided.innerRef}
                                                                        {...provided.draggableProps}
                                                                        {...provided.dragHandleProps}
                                                                    >

                                                                        <div key={index}>
                                                                            <Row gutter={24} wrap={false}>
                                                                                <Col
                                                                                    xxl={{span: 1}}
                                                                                    xl={{span: 1}}
                                                                                    lg={{span: 1}}
                                                                                >
                                                                                    {key >= 1 ? (<CloseOutlined
                                                                                        style={{
                                                                                            marginTop: 10,
                                                                                        }}
                                                                                        onChange={() => onChangeAddRow(index)}
                                                                                        onClick={() => remove(name)}/>) : null}
                                                                                </Col>
                                                                                <Col
                                                                                    xxl={{span: 1}}
                                                                                    xl={{span: 2}}
                                                                                    lg={{span: 2}}
                                                                                    xs={{span: 2}}
                                                                                    sm={{span: 2}}
                                                                                    md={{span: 2}}

                                                                                >
                                                                                    <Form.Item
                                                                                        {...restField}
                                                                                        name={[name, "columnName"]}
                                                                                        // label={key < 1 && t("salary-config.fields.columnName")}
                                                                                        initialValue={key < 1 && "A"}>
                                                                                        <Input disabled={true}/>
                                                                                    </Form.Item>
                                                                                </Col>
                                                                                <Col
                                                                                    xxl={{span: 6}}
                                                                                    xl={{span: 6}}
                                                                                    lg={{span: 6}}
                                                                                >
                                                                                    <Form.Item
                                                                                        {...restField}
                                                                                        name={[name, "valueColumn"]}
                                                                                        // label={key < 1 && t("salary-config.fields.valueColumn")}
                                                                                        rules={[{
                                                                                            required: true,
                                                                                            message: `${t("salary-config.fields.valueColumn")} ${t("tnp.components.common.requireMessage")}`
                                                                                        }]}>
                                                                                        <Select
                                                                                            showSearch
                                                                                            placeholder={t("salary-config.placeholder.valueColumn")}
                                                                                            optionFilterProp="children"
                                                                                            onChange={(e,option) => {
                                                                                                onChangeKeyWord(e, name,option);
                                                                                            }}
                                                                                            filterOption={filterOption}
                                                                                            popupMatchSelectWidth={500}
                                                                                        >
                                                                                            <Option style={{color: 'orange'}} key={"STT"}
                                                                                                    value={"STT"} title={t("tnp.components.salary.text167")}>{"STT"} <br/> {t("tnp.components.salary.text167")}
                                                                                            </Option>
                                                                                            <Option style={{color: 'orange'}} key={"IMPORT"}
                                                                                                    value={"IMPORT"} enabled={true}  title={t("tnp.components.salary.text168")}>{"IMPORT"} <br/>
                                                                                                {t("tnp.components.salary.text168")}
                                                                                            </Option>
                                                                                            <Option style={{color: 'orange'}} key={"CONGTHUC"}
                                                                                                    value={"CONGTHUC"} enabled={true} title={t("tnp.components.salary.text169")}>{t("tnp.components.salary.text169")}
                                                                                            </Option>
                                                                                            <Option style={{color: 'orange'}} key={"HANGSO"}
                                                                                                    value={"HANGSO"} enabled={true} title={t("tnp.components.salary.text170")} > {t("tnp.components.salary.text170")}
                                                                                            </Option>
                                                                                            {mapperKeyWord(dataKeyWord)}
                                                                                            {getKeyWorkEspecially(dataKeyWorkEspecially)}
                                                                                            {getTaskLabelReference(dataTaskLabel)}
                                                                                            {getDataReference(t)}
                                                                                            {getDoPosReference(t)}
                                                                                        </Select>
                                                                                    </Form.Item>
                                                                                </Col>
                                                                                <Col
                                                                                    xxl={{span: 4}}
                                                                                    xl={{span: 4}}
                                                                                    lg={{span: 4}}>
                                                                                    <Form.Item
                                                                                        {...restField}
                                                                                        name={[name, "titleColumn"]}
                                                                                        // label={key < 1 && t("salary-config.fields.titleColumn")}
                                                                                        rules={[{
                                                                                            required: true,
                                                                                            message: `${t("salary-config.fields.titleColumn")} ${t("tnp.components.common.requireMessage")}`
                                                                                        }
                                                                                        ]
                                                                                        }>
                                                                                        <Input/>
                                                                                    </Form.Item>
                                                                                </Col>
                                                                                <Col
                                                                                    xxl={{span: 6}}
                                                                                    xl={{span: 6}}
                                                                                    lg={{span: 6}}
                                                                                >
                                                                                    <Form.Item
                                                                                        {...restField}
                                                                                        name={[name, "keyColumn"]}
                                                                                        // label={key < 1 && t("salary-config.fields.keyColumn")}
                                                                                        rules={[
                                                                                            {
                                                                                                required: true,
                                                                                                message: `${t("salary-config.fields.keyColumn")} ${t("tnp.components.common.requireMessage")}`
                                                                                            },
                                                                                            {
                                                                                                min: 2,
                                                                                                message: t("tnp.components.salary.keyColumnMin2"),
                                                                                                warningOnly : true,
                                                                                            },
                                                                                            {
                                                                                                pattern: /^[A-Za-z0-9_]+$/,
                                                                                                message: t("tnp.components.salary.keyContainSpecialChar"),
                                                                                                warningOnly : true,
                                                                                            },
                                                                                            {
                                                                                                pattern: /^(?![A-Za-z]{1,3}[0-9]+$).*$/,
                                                                                                message: t("tnp.components.salary.keyContainExcelReference"),
                                                                                                warningOnly : true,
                                                                                            },
                                                                                            // {
                                                                                            //     // pattern: "^[0-9a-zA-Z_]{2,}$",
                                                                                            //     pattern: "^(?![A-Za-z]{1,3}[0-9]{2,}$).*$",
                                                                                            //     message: t("salary-config.text1")
                                                                                            // }
                                                                                        ]}
                                                                                    >
                                                                                        <Input
                                                                                            disabled={disableItems.has(name)}
                                                                                            placeholder={t("salary-config.placeholder.keyColumn")}
                                                                                            suffix={  <CopyOutlined
                                                                                                onClick={() => {
                                                                                                    const text = form.getFieldValue("salaryColumns")[name]?.keyColumn;
                                                                                                    try {
                                                                                                        if(text){
                                                                                                            navigator.clipboard.writeText(text).then(r => {
                                                                                                                message.success(t("tnp.components.salary.copy"),2)

                                                                                                            })
                                                                                                        }
                                                                                                        else {
                                                                                                            message.warning(t("tnp.components.salary.copyEmpty"), 2).then(r => {})
                                                                                                        }
                                                                                                    }
                                                                                                    catch (e) {
                                                                                                        console.error(e)
                                                                                                    }
                                                                                                }}
                                                                                                style={{
                                                                                                    cursor: "pointer",
                                                                                                    fontSize: 14,
                                                                                                    color: "var(--primary-color)"
                                                                                                }}
                                                                                            />}
                                                                                        />
                                                                                    </Form.Item>
                                                                                </Col>
                                                                                <Col
                                                                                    xxl={{span: 7}}
                                                                                    xl={{span: 7}}
                                                                                    lg={{span: 7}}>
                                                                                    <Form.Item
                                                                                        {...restField}
                                                                                        name={[name, "calculation"]}
                                                                                        // label={key < 1 && t("salary-config.fields.calculation")}
                                                                                        initialValue={""}
                                                                                    >

                                                                                        {/*tooltip={*/}
                                                                                        {/*    t("formulaPlaceholder.formula")*/}
                                                                                        {/*}*/}

                                                                                        {dataKeyWord?.length > 0 &&
                                                                                            <Calculation
                                                                                                disable = {disableItems.has(name)}
                                                                                                dataKeyWord={dataKeyWord}/>}
                                                                                    </Form.Item>

                                                                                </Col>
                                                                                <Col
                                                                                    xxl={{span: 8}}
                                                                                    xl={{span: 8}}
                                                                                    lg={{span: 8}}
                                                                                >
                                                                                    <Form.Item
                                                                                        {...restField}
                                                                                        name={[name, "rowValue"]}
                                                                                        initialValue={"valuelastrow"}
                                                                                        // label={key < 1 && t("salary-config.fields.rowValue")}
                                                                                    >

                                                                                        <Select
                                                                                            showSearch
                                                                                            placeholder={t("salary-config.placeholder.rowValue")}
                                                                                            optionFilterProp="children"
                                                                                        >
                                                                                            <Option
                                                                                                value="totalrows">{t("salary-config.rowValue.totalrows")}</Option>
                                                                                            <Option
                                                                                                value="minvaluerows">{t("salary-config.rowValue.minvaluerows")}</Option>
                                                                                            <Option
                                                                                                value="maxvaluerows">{t("salary-config.rowValue.maxvaluerows")}</Option>
                                                                                            <Option
                                                                                                value="valuelastrow">{t("salary-config.rowValue.valuelastrow")}</Option>
                                                                                            <Option
                                                                                                value="mediumvaluerows">{t("salary-config.rowValue.mediumvaluerows")}</Option>
                                                                                            {/*<Option*/}
                                                                                            {/*    value="formula">{t("salary-config.rowValue.formula")}</Option>*/}
                                                                                        </Select>
                                                                                    </Form.Item>
                                                                                </Col>
                                                                                <Col
                                                                                    xxl={{span: 3}}
                                                                                    xl={{span: 4}}
                                                                                    lg={{span: 4}}
                                                                                >
                                                                                    <Form.Item
                                                                                        {...restField}
                                                                                        name={[name, "typeValue"]}
                                                                                        initialValue={"word"}
                                                                                        // label={key < 1 && t("salary-config.fields.typeValue")}>
                                                                                    >
                                                                                        <Select
                                                                                            placeholder={t("salary-config.placeholder.typeValue")}
                                                                                            optionFilterProp="children"
                                                                                            // disabled={disabledTypeValue}
                                                                                        >
                                                                                            <Option
                                                                                                value="number">{t("salary-config.typeValue.number")}</Option>
                                                                                            <Option
                                                                                                value="word">{t("salary-config.typeValue.word")}</Option>
                                                                                        </Select>
                                                                                    </Form.Item>
                                                                                </Col>
                                                                                <Col
                                                                                    xxl={{span: 3}}
                                                                                    xl={{span: 4}}
                                                                                    lg={{span: 4}}
                                                                                >
                                                                                    <Form.Item
                                                                                        {...restField}
                                                                                        name={[name, "formatOption"]}
                                                                                        initialValue={"other"}

                                                                                        // label={key < 1 && t("salary-config.fields.formatOption")}>
                                                                                    >
                                                                                        <Select
                                                                                            placeholder={t("salary-config.placeholder.formatOption")}
                                                                                            optionFilterProp="children"
                                                                                            popupMatchSelectWidth={250}
                                                                                        >
                                                                                            <Option
                                                                                                value="money">{t("tnp.components.salary.currency")}</Option>
                                                                                            <Option
                                                                                                value="other">{t("tnp.components.salary.nonCurrency")}</Option>
                                                                                        </Select>
                                                                                    </Form.Item>
                                                                                </Col>
                                                                                <Col
                                                                                    xxl={{span: 3}}
                                                                                    xl={{span: 4}}
                                                                                    lg={{span: 4}}
                                                                                >
                                                                                    <Form.Item
                                                                                        {...restField}
                                                                                        name={[name, "paycheck"]}
                                                                                        initialValue={"presently"}
                                                                                        // label={key < 1 && t("salary-config.fields.paycheck")}
                                                                                    >
                                                                                        <Select
                                                                                            placeholder={t("salary-config.placeholder.paycheck")}
                                                                                            optionFilterProp="children"
                                                                                        >
                                                                                            <Option
                                                                                                value="presently">{t("salary-config.paycheck.presently")} </Option>
                                                                                            <Option
                                                                                                value="hide">{t("salary-config.paycheck.hide")}</Option>
                                                                                        </Select>
                                                                                    </Form.Item>
                                                                                </Col>
                                                                                <Col
                                                                                    xxl={{span: 4}}
                                                                                    xl={{span: 4}}
                                                                                    lg={{span: 4}}
                                                                                >
                                                                                    <Form.Item
                                                                                        {...restField}
                                                                                        name={[name, "valueSynthetic"]}
                                                                                        fieldKey={[fieldKey, "valueSynthetic",]}
                                                                                        // label={key < 1 && t("salary-config.fields.valueSynthetic")}
                                                                                    >

                                                                                        <Select
                                                                                            placeholder={t("salary-config.placeholder.rowValue")}
                                                                                            optionFilterProp="children"
                                                                                            popupMatchSelectWidth={300}
                                                                                        >

                                                                                            <Option
                                                                                                value="sumrowvalues">{t("salary-config.valueSynthetic.sumrowvalues")}</Option>
                                                                                            <Option
                                                                                                value="minvaluerow">{t("salary-config.valueSynthetic.minvaluerow")}</Option>
                                                                                            <Option
                                                                                                value="maxvaluerow">{t("salary-config.valueSynthetic.maxvaluerow")}</Option>
                                                                                            <Option
                                                                                                value="mediumvaluerows">{t("salary-config.valueSynthetic.mediumvaluerows")}</Option>
                                                                                        </Select>
                                                                                    </Form.Item>
                                                                                </Col>

                                                                                <Col
                                                                                    xxl={{span: 5}}
                                                                                    xl={{span: 5}}
                                                                                    lg={{span: 5}}
                                                                                >
                                                                                    <Form.Item
                                                                                        {...restField}
                                                                                        name={[name, "describe"]}
                                                                                        fieldKey={[fieldKey, "describe",]}
                                                                                        // label={key < 1 && t("salary-config.fields.describe")}
                                                                                    >
                                                                                        <Input/>
                                                                                    </Form.Item>
                                                                                </Col>

                                                                            </Row>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </Draggable>
                                                        )
                                                    }
                                                )}
                                                <Form.Item>
                                                    <PlusCircleOutlined
                                                        onClick={() => {
                                                            add()
                                                            onChangeAddRow(fields)
                                                        }}
                                                        style={{fontSize: 20}}
                                                    />
                                                </Form.Item>
                                            </>

                                            {provided.placeholder}
                                        </div>
                                    )}
                                </Droppable>
                            </DragDropContext>
                        )}
                    </Form.List>

                    {/*<Row gutter={12} wrap={false} className={"mb-6"}>*/}
                    {/*    <Col*/}
                    {/*        xxl={{span: 8}}*/}
                    {/*        xl={{span: 8}}*/}
                    {/*        lg={{span: 8}}*/}
                    {/*    >*/}
                    {/*        <Form.Item*/}
                    {/*            label={*/}
                    {/*                <>*/}
                    {/*                    <span>Mẫu phiếu lương </span>*/}
                    {/*                    <Button type="link"*/}

                    {/*                            style={{*/}
                    {/*                                paddingLeft : 3*/}
                    {/*                            }}*/}
                    {/*                            onClick={() => {*/}
                    {/*                                message.loading("Đang tải file mẫu",1)*/}
                    {/*                                getExportTemplateSalaryTable(0).then((res => {*/}
                    {/*                                    const url = window.URL.createObjectURL(new Blob([res?.content]));*/}
                    {/*                                    const link = document.createElement('a');*/}
                    {/*                                    link.href = url;*/}
                    {/*                                    link.setAttribute('download',*/}
                    {/*                                        res?.fileName);*/}
                    {/*                                    document.body.appendChild(link);*/}
                    {/*                                    link.click();*/}
                    {/*                                }));*/}

                    {/*                            }}>*/}
                    {/*                        <FileExcelOutlined />*/}

                    {/*                    </Button>*/}
                    {/*                </>*/}
                    {/*            }*/}
                    {/*        >*/}
                    {/*            <SimpleDocument*/}
                    {/*                externalReferenceCode={externalReferenceCode}*/}
                    {/*                moduleId={ModuleId.SALARY}*/}
                    {/*                appId={AppId.SALARY.SALARY_TABLE}*/}
                    {/*                accept={'.xlsx'}*/}
                    {/*            />*/}
                    {/*        </Form.Item>*/}
                    {/*    </Col>*/}
                    {/*</Row>*/}

                </div>
            </DG_Form>
        </div>
    );
};

export default AddSalaryConfig;

export function Calculation({value, defaultValue, dataKeyWord, onChange,disable, ...props}) {
    const defaultItems = [
        {
            label: <div>
                <div className={"flex justify-between items-center"}>
                    <div>
                        <p className={"text-[rgb(26,47,54)] font-bold"}>{t("tnp.components.salary.text171")}</p>
                        <p className={"text-[rgb(118,130,134)] text-[12px]"}>
                            {"+, -, *, /, %, ^, =, >, >=, <, <=, !=, in, not in, contain, start, end, &&, ||"}
                        </p>
                    </div>
                    <RightOutlined/>
                </div>
            </div>,
            key: "cal",
            onClick: () => {
                setItems(calItems)
                setType("group")
                focusCurrent()
            }
        },
        {
            label: <div>
                <div className={"flex justify-between items-center"}>
                    <div>
                        <p className={"text-[rgb(26,47,54)] font-bold"}>{t("tnp.components.salary.text172")}</p>
                        <p className={"text-[rgb(118,130,134)] text-[12px]"}>{t("tnp.components.salary.text173")}</p>
                    </div>
                    <RightOutlined/>
                </div>
            </div>,
            key: "keyword",
            onClick: () => {
                setItems(keywordItems)
                setType("default")
                focusCurrent()
            }
        },
    ];

    const [type, setType] = useState(null)
    const [visible, setVisible] = useState(false)
    const [items, setItems] = useState(defaultItems)
    const currentValue = useRef("")

    const autoRef = useRef(null)

    useEffect(() => {
        currentValue.current = value
    }, [value])


    const calMath = [
        {
            label: "a+b",
            key: "+",

        },
        {
            label: "a-b",
            key: "-",

        },
        {
            label: "a*b",
            key: "*",

        },
        {
            label: "a/b",
            key: "/",

        },
        {
            label: "a^b",
            key: "^",

        },
        {
            label: "a%b",
            key: "%",

        }
    ];
    const calEqual = [
        {
            label: "a=b",
            key: "=",

        },
        {
            label: "a!=b",
            key: "!=",

        },
        {
            label: "a>b",
            key: ">",

        },
        {
            label: "a>=b",
            key: ">=",

        },
        {
            label: "a<b",
            key: "<",

        },
        {
            label: "a<=b",
            key: "<=",

        }
    ];
    const calLogic = [
        {
            label: "a&&b",
            key: "&&",

        },
        {
            label: "a||b",
            key: "||",

        },
        {
            label: "a!b",
            key: "!",

        },

    ];
    const calArrayString = [
        {
            label: "a in [value1, value2, value3, ...]",
            key: "in",

        },
        {
            label: "a not in [value1, value2, value3, ...]",
            key: "not in",

        },
        {
            label: "text1 contain text2",
            key: "contain",

        },
        {
            label: "\"text1\" start with \"text2\"",
            key: "start with",

        },
        {
            label: "\"text1\" end with \"text2\"",
            key: "end with",

        },

    ];

    const calItems = [
        {
            label: <div className={"flex items-center gap-[12px]"}>
                <LeftOutlined/>
                <div>
                    <p className={"text-[rgb(26,47,54)] font-bold"}>{t("tnp.components.salary.text171")}</p>
                    <p className={"text-[rgb(118,130,134)] text-[12px]"}>
                        {"+, -, *, /, %, ^, =, >, >=, <, <=, !=, in, not in, contain, start, end, &&, ||"}
                    </p>
                </div>
            </div>,
            key: "back",
            onClick: () => {
                onReset()
            },
        },
        {
            label: t("tnp.components.salary.math"),
            type: "group",
            children: [
                ...calMath.map((cal) => {
                    return {
                        key: cal.key,
                        label: <div>
                            <p className={"text-[rgb(26,47,54)] font-bold"}>{cal.key}</p>
                            <p className={"text-[rgb(118,130,134)] text-[12px]"}>{cal.label}</p>
                        </div>,
                        onClick: () => {
                            onChangeAuto(currentValue.current, cal.key)
                            onResetAll()
                        }
                    }
                }),

            ]
        },
        {
            label: t("tnp.components.salary.compare"),
            type: "group",
            children: [
                ...calEqual.map((cal) => {
                    return {
                        key: cal.key,
                        label: <div>
                            <p className={"text-[rgb(26,47,54)] font-bold"}>{cal.key}</p>
                            <p className={"text-[rgb(118,130,134)] text-[12px]"}>{cal.label}</p>
                        </div>,
                        onClick: () => {
                            onChangeAuto(currentValue.current, cal.key)
                            onResetAll()
                        }
                    }
                }),

            ]
        },
        {
            label: "Logic",
            type: "group",
            children: [
                ...calLogic.map((cal) => {
                    return {
                        key: cal.key,
                        label: <div>
                            <p className={"text-[rgb(26,47,54)] font-bold"}>{cal.key}</p>
                            <p className={"text-[rgb(118,130,134)] text-[12px]"}>{cal.label}</p>
                        </div>,
                        onClick: () => {
                            onChangeAuto(currentValue.current, cal.key)
                            onResetAll()
                        }
                    }
                }),

            ]
        },
        {
            label: t("tnp.components.salary.arrayString"),
            type: "group",
            children: [
                ...calArrayString.map((cal) => {
                    return {
                        key: cal.key,
                        label: <div>
                            <p className={"text-[rgb(26,47,54)] font-bold"}>{cal.key}</p>
                            <p className={"text-[rgb(118,130,134)] text-[12px]"}>{cal.label}</p>
                        </div>,
                        onClick: () => {
                            onChangeAuto(currentValue.current, cal.key)
                            onResetAll()
                        }
                    }
                }),

            ]
        },
    ];

    const keywordItems = [
        {
            label: <div className={"flex items-center gap-[12px]"}>
                <LeftOutlined/>
                <div>
                    <p className={"text-[rgb(26,47,54)] font-bold"}>{t("tnp.components.salary.text172")}</p>
                    <p className={"text-[rgb(118,130,134)] text-[12px]"}>{t("tnp.components.salary.text173")}</p>
                </div>
            </div>,
            key: "back",
            onClick: () => {
                onReset()
            },
        },
        ...dataKeyWord?.map(data => {
            return {
                key: data?.column,
                note: data?.name,
                label: <div>
                    <p className={"text-[rgb(26,47,54)] font-bold"}>{data?.column}</p>
                    <p className={"text-[rgb(118,130,134)] text-[12px]"}>{data?.name}</p>
                </div>,
                onClick: () => {
                    onChangeAuto(currentValue.current, data?.column)
                    onResetAll()
                }
            }
        })
    ];

    function onReset() {
        setItems(defaultItems)
        setType(null)
    }

    function onResetAll() {
        setItems(defaultItems)
        setVisible(false)
        setType(null)
        focusCurrent()
    }

    function focusCurrent() {
        const node = document.getElementById(props.id)
        const {selectionStart} = node

        node.setSelectionRange(selectionStart, selectionStart);
        node.focus()
    }

    function onChangeAuto(value, extraText = "") {
        const node = document.getElementById(props.id)
        const {selectionStart} = node

        if (value === undefined) {
            value = ""
        }
        currentValue.current = value?.substring(0, selectionStart) + extraText + value?.substring(selectionStart)
        onChange && onChange(currentValue.current)
    }


    return <>
        <Dropdown
            disabled={disable}
            menu={{
                items,
                style: {
                    width: 700,
                    maxHeight: 600,
                    overflow: 'auto'
                }
            }}
            trigger={["click"]}
            open={visible}
            onOpenChange={(visible) => {
                if (!visible) {
                    onReset()
                } else {
                    focusCurrent()
                }

                setVisible(visible)
            }}
            placement={"top"}
            dropdownRender={(menus) => {
                return !!type ? type === "group" ? <GroupMenu menus={menus}/> : <DefaultMenu menus={menus}/> : menus
            }}
        >
            <AutoComplete value={value}
                          onChange={(data) => onChangeAuto(data, "")}
                          {...props}
                          ref={autoRef}
            />
        </Dropdown>
    </>

}

function DefaultMenu({menus}) {

    const headerItem = menus?.props?.items[0]
    const [originalData, setOriginalData] = useState([])
    const [bodyItems, setBodyItems] = useState([])
    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
        setOriginalData(menus?.props?.items?.filter((item, index) => index !== 0))
        setBodyItems(menus?.props?.items?.filter((item, index) => index !== 0))
    }, [menus])

    return <div
        className={"ant-dropdown-menu ant-dropdown-menu-root ant-dropdown-menu-vertical ant-dropdown-menu-light css-dev-only-do-not-override-1qvx3y1"}
        style={{
            width: 700
        }}
    >
        <div className={"cursor-pointer px-2 py-3"} onClick={headerItem?.onClick}>
            {headerItem?.label}
        </div>
        <Input className={"py-2"}
               ref={inputRef}
               onChange={(e) => setBodyItems(originalData?.filter(data => data?.key?.toLowerCase()
                       ?.normalize("NFD")
                       .replace(/[\u0300-\u036f]/g, "")
                       ?.includes(e.target.value?.toLowerCase()?.normalize("NFD")
                           ?.replace(/[\u0300-\u036f]/g, "")) ||
                   data?.note?.toLowerCase()
                       ?.normalize("NFD")
                       .replace(/[\u0300-\u036f]/g, "")
                       ?.includes(e.target.value?.toLowerCase()?.normalize("NFD")
                           ?.replace(/[\u0300-\u036f]/g, ""))
               ))}/>
        <div style={{
            maxHeight: 500,
            overflow: 'auto'
        }}>
            {bodyItems?.length > 0 ? (
                bodyItems?.map((data, index) => {

                    return <div
                        key={index}
                        className={"cursor-pointer px-2 py-3 hover:bg-[rgba(0,0,0,0.1)] transition-all"}
                        onClick={data?.onClick}
                        style={{
                            borderBottom: "1px solid #E3E6E6"
                        }}
                    >
                        {data?.label}
                    </div>
                })
            ) : <><Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("tnp.components.salary.text174")}/></>}

        </div>
    </div>
}

function GroupMenu({menus}) {

    const headerItem = menus?.props?.items[0]
    const groups = menus?.props?.items?.filter((item, index) => index !== 0)

    return <div
        className={"ant-dropdown-menu ant-dropdown-menu-root ant-dropdown-menu-vertical ant-dropdown-menu-light css-dev-only-do-not-override-1qvx3y1"}
        style={{
            width: 700
        }}
    >
        <div className={"cursor-pointer px-2 py-3"} onClick={headerItem?.onClick}>
            {headerItem?.label}
        </div>

        <Row>
            {groups?.map((data, index) => {

                return <Col span={12} key={index}>
                    <div
                        className={"font-bold px-2 py-3"}
                        style={{
                            boxShadow: "0 1px 3px #EDEFEF"
                        }}
                    >
                        {data?.label}
                    </div>

                    <Row className={"p-3"}>
                        {data?.children?.map((child, i) => {

                            return <Col span={8}
                                        className={"px-2 py-3 cursor-pointer hover:bg-[rgba(0,0,0,0.1)] transition-all"}
                                        onClick={child?.onClick}
                                        style={{
                                            borderTop: "1px solid #EDEFEF"
                                        }}
                            >
                                {child?.label}
                            </Col>
                        })}
                    </Row>
                </Col>
            })}
        </Row>
    </div>
}

export const colunmsKeys =
    [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "AA",
        "AB",
        "AC",
        "AD",
        "AE",
        "AF",
        "AG",
        "AH",
        "AI",
        "AJ",
        "AK",
        "AL",
        "AM",
        "AN",
        "AO",
        "AP",
        "AQ",
        "AR",
        "AS",
        "AT",
        "AU",
        "AV",
        "AW",
        "AX",
        "AY",
        "AZ",
        "BA",
        "BB",
        "BC",
        "BD",
        "BE",
        "BF",
        "BG",
        "BH",
        "BI",
        "BJ",
        "BK",
        "BL",
        "BM",
        "BN",
        "BO",
        "BP",
        "BQ",
        "BR",
        "BS",
        "BT",
        "BU",
        "BV",
        "BW",
        "BX",
        "BY",
        "BZ",
        "CA",
        "CB",
        "CC",
        "CD",
        "CE",
        "CF",
        "CG",
        "CH",
        "CI",
        "CJ",
        "CK",
        "CL",
        "CM",
        "CN",
        "CO",
        "CP",
        "CQ",
        "CR",
        "CS",
        "CT",
        "CU",
        "CV",
        "CW",
        "CX",
        "CY",
        "CZ",
        "DA",
        "DB",
        "DC",
        "DD",
        "DE",
        "DF",
        "DG",
        "DH",
        "DI",
        "DJ",
        "DK",
        "DL",
        "DM",
        "DN",
        "DO",
        "DP",
        "DQ",
        "DR",
        "DS",
        "DT",
        "DU",
        "DV",
        "DW",
        "DX",
        "DY",
        "DZ",
        "EA",
        "EB",
        "EC",
        "ED",
        "EE",
        "EF",
        "EG",
        "EH",
        "EI",
        "EJ",
        "EK",
        "EL",
        "EM",
        "EN",
        "EO",
        "EP",
        "EQ",
        "ER",
        "ES",
        "ET",
        "EU",
        "EV",
        "EW",
        "EX",
        "EY",
        "EZ",
        "FA",
        "FB",
        "FC",
        "FD",
        "FE",
        "FF",
        "FG",
        "FH",
        "FI",
        "FJ",
        "FK",
        "FL",
        "FM",
        "FN",
        "FO",
        "FP",
        "FQ",
        "FR",
        "FS",
        "FT",
        "FU",
        "FV",
        "FW",
        "FX",
        "FY",
        "FZ",
        "GA",
        "GB",
        "GC",
        "GD",
        "GE",
        "GF",
        "GG",
        "GH",
        "GI",
        "GJ",
        "GK",
        "GL",
        "GM",
        "GN",
        "GO",
        "GP",
        "GQ",
        "GR",
        "GS",
        "GT",
        "GU",
        "GV",
        "GW",
        "GX",
        "GY",
        "GZ",
        "HA",
        "HB",
        "HC",
        "HD",
        "HE",
        "HF",
        "HG",
        "HH",
        "HI",
        "HJ",
        "HK",
        "HL",
        "HM",
        "HN",
        "HO",
        "HP",
        "HQ",
        "HR",
        "HS",
        "HT",
        "HU",
        "HV",
        "HW",
        "HX",
        "HY",
        "HZ",
        "IA",
        "IB",
        "IC",
        "ID",
        "IE",
        "IF",
        "IG",
        "IH",
        "II",
        "IJ",
        "IK",
        "IL",
        "IM",
        "IN",
        "IO",
        "IP",
        "IQ",
        "IR",
        "IS",
        "IT",
        "IU",
        "IV",
        "IW",
        "IX",
        "IY",
        "IZ",
        "JA",
        "JB",
        "JC",
        "JD",
        "JE",
        "JF",
        "JG",
        "JH",
        "JI",
        "JJ",
        "JK",
        "JL",
        "JM",
        "JN",
        "JO",
        "JP",
        "JQ",
        "JR",
        "JS",
        "JT",
        "JU",
        "JV",
        "JW",
        "JX",
        "JY",
        "JZ",
        "KA",
        "KB",
        "KC",
        "KD",
        "KE",
        "KF",
        "KG",
        "KH",
        "KI",
        "KJ",
        "KK",
        "KL",
        "KM",
        "KN",
        "KO",
        "KP",
        "KQ",
        "KR",
        "KS",
        "KT",
        "KU",
        "KV",
        "KW",
        "KX",
        "KY",
        "KZ",
        "LA",
        "LB",
        "LC",
        "LD",
        "LE",
        "LF",
        "LG",
        "LH",
        "LI",
        "LJ",
        "LK",
        "LL",
        "LM",
        "LN",
        "LO",
        "LP",
        "LQ",
        "LR",
        "LS",
        "LT",
        "LU",
        "LV",
        "LW",
        "LX",
        "LY",
        "LZ",
        "MA",
        "MB",
        "MC",
        "MD",
        "ME",
        "MF",
        "MG",
        "MH",
        "MI",
        "MJ",
        "MK",
        "ML",
        "MM",
        "MN",
        "MO",
        "MP",
        "MQ",
        "MR",
        "MS",
        "MT",
        "MU",
        "MV",
        "MW",
        "MX",
        "MY",
        "MZ",
        "NA",
        "NB",
        "NC",
        "ND",
        "NE",
        "NF",
        "NG",
        "NH",
        "NI",
        "NJ",
        "NK",
        "NL",
        "NM",
        "NN",
        "NO",
        "NP",
        "NQ",
        "NR",
        "NS",
        "NT",
        "NU",
        "NV",
        "NW",
        "NX",
        "NY",
        "NZ",
        "OA",
        "OB",
        "OC",
        "OD",
        "OE",
        "OF",
        "OG",
        "OH",
        "OI",
        "OJ",
        "OK",
        "OL",
        "OM",
        "ON",
        "OO",
        "OP",
        "OQ",
        "OR",
        "OS",
        "OT",
        "OU",
        "OV",
        "OW",
        "OX",
        "OY",
        "OZ",
        "PA",
        "PB",
        "PC",
        "PD",
        "PE",
        "PF",
        "PG",
        "PH",
        "PI",
        "PJ",
        "PK",
        "PL",
        "PM",
        "PN",
        "PO",
        "PP",
        "PQ",
        "PR",
        "PS",
        "PT",
        "PU",
        "PV",
        "PW",
        "PX",
        "PY",
        "PZ",
        "QA",
        "QB",
        "QC",
        "QD",
        "QE",
        "QF",
        "QG",
        "QH",
        "QI",
        "QJ",
        "QK",
        "QL",
        "QM",
        "QN",
        "QO",
        "QP",
        "QQ",
        "QR",
        "QS",
        "QT",
        "QU",
        "QV",
        "QW",
        "QX",
        "QY",
        "QZ",
        "RA",
        "RB",
        "RC",
        "RD",
        "RE",
        "RF",
        "RG",
        "RH",
        "RI",
        "RJ",
        "RK",
        "RL",
        "RM",
        "RN",
        "RO",
        "RP",
        "RQ",
        "RR",
        "RS",
        "RT",
        "RU",
        "RV",
        "RW",
        "RX",
        "RY",
        "RZ",
        "SA",
        "SB",
        "SC",
        "SD",
        "SE",
        "SF"
    ]

